import React from "react";

import { useTranslation } from "react-i18next";

import usePeriodFilter from "@/src/hooks/usePeriodFilter";

import ContentViewsTimelineCard from "./ContentViewsTimelineCard";
import CountriesSection from "./CountriesSection";
import DevicesCard from "./DevicesCard";
import PageTitle from "../../common/PageTitle";
import AnalyticsPage from "../AnalyticsPage";
import SignupsAndSubscriptionsSection from "./signups/SignupsAndSubscriptionsSection";
import AnalyticsPeriodPicker from "../charts/AnalyticsPeriodPicker";
import CustomerKpiGrid from "../kpi/CustomerKpiGrid";

import type { JSX } from "react";

function DashboardAdmin(): JSX.Element {
  const { t } = useTranslation("editor-analytics");
  const { period, setPeriod } = usePeriodFilter();

  return (
    <AnalyticsPage
      actions={<AnalyticsPeriodPicker onChange={setPeriod} period={period} />}
      heading={<PageTitle>{t("editor-menu:dashboard")}</PageTitle>}
    >
      <CustomerKpiGrid />
      <SignupsAndSubscriptionsSection period={period} />
      <ContentViewsTimelineCard period={period} />
      <CountriesSection period={period}>
        <DevicesCard period={period} />
      </CountriesSection>
    </AnalyticsPage>
  );
}

export default DashboardAdmin;
